export function shouldShowAdtechBanner(type?: string, topBannerId?: string) {
  return (
    type === "brand" || type === "browse" || (type === "search" && !topBannerId)
  );
}

export function shouldShowTopBanner(type?: string, topBannerId?: string) {
  return type === "search" && !!topBannerId;
}
